import type { BaseTranslation } from '../i18n-types';

/** @deprecated */
export const main = {
    id: 'ID: {id:string}',
    cancel: 'Cancel',
    continue: 'Continue',
    disable: 'Disable',
    delete: 'Delete',
    optional: 'Optional',
    close: 'Close',
    enabled: 'Enabled',
    disabled: 'Disabled',
    userTurnedOffCamera: 'This user turned the camera off',
    youTurnedOffCamera: 'You turned your camera off',
    limitedOffer: 'Limited offer',
    userHasPaidMinutes: 'This user has a balance of paid minutes',

    block: {
        title: 'Account Restricted',
        subtitle: `Your access to {appName:string} has been revoked due to a breach of platform rules. If you think this is an error, please contact us at <a href="mailto:{supportEmail:string}">{supportEmail:string}</a> for further assistance.`,
        duplicateAccount: `Duplicate account detected: <b>{username:string}</b><br />Please contact support at <a href="mailto:{supportEmail:string}">{supportEmail:string}</a>`,
    },

    ban: {
        and: ' and ',
        title: 'Account Suspended until {until:string}',
        subtitle: `Your account has been temporarily suspended until the {until:string} due to multiple reports from other users involving <b>{reasons:string}</b>. Please refrain from infractions of our rules. For a comprehensive list of rules, please refer to our  <a href="{termsOfUseLink:string}" class="link" target="_blank">Terms of Use</a>.`,
        subtitleOperator: `Your account has been temporarily suspended until the {until:string} due to multiple reports from other users involving <b>{reasons:string}</b>. Please refrain from infractions of our rules. For a comprehensive list of rules, please review all our rules <a href="{chatRules:string}" class="link" target="_blank">here</a>.`,
        subtitleNudity: `Your account has been temporarily suspended until the {until:string} due to report involving <b>{reasons:string}</b>. For a comprehensive list of rules, please review all our rules <a href="{chatRules:string}" class="link" target="_blank">here</a>.`,
    },
    footer: {
        menu: {
            privacyPolicyLabel: 'Privacy Policy',
            termsOfUseLabel: 'Terms of use',
            contactUsLabel: 'Contact us',
            chatRules: 'Chat Rules',
        },
        buttonVersionMobile: 'Mobile Version',
        buttonVersionDesktop: 'Desktop Version',
        complianceLabel: '18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement',
        copyrightLabel: `© {year:number}, {appName:string}`,
        talkToStrangers: 'Talk to Strangers',
        sitemap: 'Comparisons list',
    },

    error: {
        request: 'Something went wrong, please try again',
        metaTitle: 'Error {code:string}',
        metaDescription: '{message:string}',
        code404: {
            title: 'Alien Abduction Alert!',
            description:
                'Uh-oh! Looks like aliens swiped this page. Don’t worry, you can explore other earthly content.',
        },
        code500: {
            title: 'Oops! Internal server error.',
            description:
                'Don’t worry, we are already fixing this problem. Please try again in a few minutes.',
        },
        codeXXX: {
            title: 'Oops! An error occurred.',
            description: 'Please try again.',
        },
        sessionExists: {
            title: 'Multiple windows are not allowed',
            description: 'Please select the correct window to continue to use the platform, or proceed with this one',
            button: 'Continue current session',
        },
        goToMainPage: 'Go to main page',
        tryAgaing: 'Try again',
        searchFailed: {
            title: 'Something went wrong',
            description:
                'Unfortunately we couldn\'t get your video stream. Please try again later. If the problem persists, try a different browser or device.',
        },
        connectionAborted: {
            reconnecting: 'Reconnecting',
            waitToContinue: 'Please wait a moment to continue chatting',
        },
        noInternet: {
            title: 'No internet connection',
            description: 'Check your internet connection and try again',
        },
        reconnecting: {
            reconnectionTitle: 'Reconnecting with {userName:string}',
            partnerLeftTitle: '{userName:string} left the room',
            operatorSelfReconnectingDescription: 'You are currently offline and not earning money for the conversation. Please wait',
            operatorPartnerReconnectingDescription: 'The user is currently offline. You are not earning from them, please wait',
            userSelfReconnectingDescription: 'You are currently offline, we are not deducting any minutes from your account. Please wait.',
            userPartnerReconnectingDescription: 'The user is currently offline, we are not deducting any minutes from your account, please wait',
            selfDisconnectedDescription: 'Unfortunately, we were unable to restore the connection. You can wait for your connection to be reestablished or start a new search',
            partnerDisconnectedDescription: 'Unfortunately, we were unable to restore the connection. You can wait for the user to reconnect or start a new search',
            partnerLeftDescription: 'It seems that {userName:string} has left the room. They might be reloading the page or have closed the tab. Please wait a few moments—they’ll be back soon.',
            startNew: 'Start a new search',
        },
    },

    roomStartPage: {
        buttonLabel: 'Start chat',
        stopButtonLabel: 'Stop',
        nextButtonLabel: 'Next',
        watchStories: 'Watch stories',
    },

    roomSearchPage: {
        lookingForMatch: 'Looking for a perfect match...',
        establishingConnection: 'Establishing connection...',
        prepareVideoStream: 'Preparing your video stream...',
        stopSearching: 'Stop searching',
        placeInLine: 'Your place in the line: {place:number}',
    },

    roomPage: {
        noCameraAndMic: 'User broadcast and microphone disabled',
        matchFoundAndWaiting: 'Match found and is waiting for you!',
        startChatNow: 'Start chat now!',
        connecting: 'Connecting with a stranger',
        connectingWith: 'Connecting with {displayName:string}...',
        loadingYourStream: 'Loading your video stream for {displayName:string}...',
        loadingYourStreamDesc: 'Please, wait a moment. He can’t see and hear you yet.',
        loadingPartner: 'Loading {displayName:string}’s video stream...',
        loadingPartnerDesc: 'You can already start chatting!',
        tooltip: {
            flipScreenBtn: 'Flip screens here',
            mutePartner: 'Now you can mute your chat partners',
        },
    },

    roomClose: {
        dialog: {
            title: 'Your call was stopped',
            text: 'Your call was stopped because you already have an active call in another tab or browser. You can only have 1 active call at a time.',
            cancelBtn: 'Cancel',
            gotItBtn: 'Got it',
        },
    },

    subscription: {
        buyMembershipDialog: {
            titleBecomePremium: 'Become Premium',
            titleGetMinutes: 'Buy <span>membership</span> to get all features',
            titleSendGift: 'Buy <span>membership</span> to send gift',
            titleCall: 'Buy <span>membership</span> to make calls',
            titlePm: 'Buy <span>membership</span> to start chat',
            titleOffCamera: 'Buy <span>membership</span> to turn off your camera',
            titleOnCamera: 'Buy <span>membership</span> to turn on your camera',
            titleOffMic: 'Buy <span>membership</span> to turn off your microphone',
            titleOnMic: 'Buy <span>membership</span> to turn on your microphone',
            titleContinue:
                'Buy <span>membership</span> to continue chatting with {operatorName:string}',
            titleStories: 'Buy <span>membership</span> to get unlimited access to stories or wait',
            features: {
                highlightAccount: 'Highlight your account for more attention',
                turnOffCamera: 'Turn off the camera whenever you want',
            },
            subtitle: 'Your free time is over. Buy premium accesses to continue.',
            subtitleV2: 'or wait to continue watching',
            billInfo: 'Payments are facilitated by #billing name#',
            billedAt: 'After {period} subscription renews at {total}',
            giftCardProduct: 'Duration of your membership will depend on your gift card balance',
        },
        buyMembershipPremiumDialog: {
            title: 'Get Premium',
            titleV2: 'Become Premium',
            titleContinue: 'Get Premium<br>to continue chatting',
            subtitle: {
                specialOffer: 'Special offer for you',
                save: 'Save {percents:number}%',
                story: 'or wait to continue watching',
            },
            paymentButton: 'Get Trial Offer',
            productContents: {
                item1: 'Unlimited search and matches',
                item2: 'Private direct calls',
                item3: 'Premium chat experience',
            },
            productContentsV2: {
                item1: 'Direct calls',
                item2: 'Private messages',
                item3: 'Dating with no limits',
                item4: 'Camera control settings',
            },
            billedAt:
                'After {period:string} you will be charged {nextTotal} monthly receiving {nextMinutes:number} minutes for every {nextPeriod:string}.',
            includedMinutes: '{minutes:number} minutes included',
            includedMinutesV2: '{minutes:number} min included',
            dayPeriod: 'day',
            nextPeriod: '{day:number} days',
            daysTrial: '{day:number}-day trial',
        },
        buyMinutesDialog: {
            title: 'Buy <span>extra minutes</span>',
            titleSendGift: 'Buy <span>extra minutes</span> to send gift',
            titleSendGiftV2: 'Buy <span>minutes</span> to send gift',
            titleCall: 'Buy <span>extra minutes</span> to continue',
            giftCost: 'Gift cost: <span>{minutes:string}</span>',
            endBalanceSubtitle:
                'Your package of minutes are over and will be <strong>renewed on {renewAt:string}</strong>. Buy extra minutes to continue right now.',
            subtitle:
                'Your time will soon run out, you have only 2 minutes left. Buy extra minutes to continue.',
            subtitleFull:
                'Your package of minutes are over and will be <b>renewed on {date}</b>. Buy extra minutes to continue right now',
            subtitleCall:
                'To make calls, you need to have more than 2 minutes left on your balance',
            autoRenewalLabel: 'Automatic balance top up',
            autoRenewalDescription:
                'Your balance will be automatically topped up for the selected minutes package when you have under 2 minutes left.',
            giftCardProduct: 'The number of minutes you receive will be determined by your gift card balance',
        },
        common: {
            bottomText:
                'Payments are facilitated by <a href="{link}" target="_blank"><img src="{imgSrc}" alt="billing" class="{imgClass}"/></a> <b>Billed as {total}</b>',
            bottomPayGarden:
                'Payments are facilitated by PayGarden',
            continueButtonText: 'Continue',
            infoText: 'No hidden fees • Cancel subscription at any time',
            month: 'month',
            months: 'months',
            OFF: 'OFF',
            minutesIncluded: 'minutes included',
            min: 'min',
            mo: 'mo',
        },
    },

    locale: {
        choose: 'Language: {locale: string}',
        dialogTitle: 'Select your language',
    },

    header: {
        timeBalanceHeader: 'Your balance:',
        timeBalanceText: '{minutes} min',
        timeBalanceButton: 'Buy minutes',
        timeBalanceButtonMembership: 'Buy membership',
        operator: {
            tooltip: 'Here you can check your income, conditions and rates',
        },
    },

    favorites: {
        title: 'Favorites',
        chatButton: 'Favorite',
        addToFavorite: 'Add to favorites',
        unfavorite: 'Unfavorite',
        added: '{displayName:string} now in your favorites',
        removed: '{displayName:string} was removed from your favorites',
        inList: '<b>{count:number} users</b> added you to their favourites list',
        favoritesTitle: 'My favorites',
        favoritedByTitle: 'Favorited by',
        online: 'Online',
        offline: 'Offline',
        dialog: {
            title: 'Remove from favorites',
            subtitle: 'Are you sure you want to remove {displayName:string} from your favorites?',
            confirm: 'Remove',
        },
        button: 'My favorites online: {count:number}',
        emptyTitle: 'My favorites online',
        emptySubtitle: 'The list of your favorite users online will be here',
        emptyFavoritesSubtitle: 'The list of your favorite users will be here',
        emptyFavoritedBySubtitle: 'The list of users who favorite you will be here',
        call: 'Call',
    },

    chatHistory: {
        title: 'Chat History',
        menuItem: 'Chat history',
        emptyTitle: 'My chat history',
        emptySubtitle: 'The list of you chat history will be here',
    },

    sidebarNavigationTab: {
        viewAll: 'View all',
    },

    userNotes: {
        dialog: {
            title: 'Notes about {displayName:string}',
        },
        toast: {
            success: 'Your note was saved',
            error: 'An error occurred while saving the note. Please try again.',
        },
        userListItemTitle: 'Write a note',
    },

    mailSubscription: {
        unsubscribe: {
            title: 'Unsubscribe',
            subtitle: `Are you sure you do not want to receive such emails from {appName:string}?`,
            unsubscribeButton: 'Unsubscribe',
            cancelButton: 'Cancel',
            subscribeAgainButton: 'Subscribe again',
            unsubscribedTitle: 'You have been successfully unsubscribed',
            updatedTitle: 'Your email preferences have been updated',
            alreadyUnsubscribedTitle: 'You have already unsubscribed',
        },
        unsubscribeFavorites: {
            subtitle: 'I don’t want to receive “My favourite is online” notifications from:',
            controlNone: 'stay subscribed',
            controlFavorite: 'from {displayName:string}',
            controlAll: 'from all my favorites',
            saveButton: 'Save',
        },
    },

    cookiesPopup: {
        description:
            'We use cookies on this website for many operations such as improving your user experience, analytics, remember your preference and settings and enable live video chat. You can read more information in our <a href="{link:string}" target="_blank">Privacy Policy</a>. By using this website, you confirm that you are 18 years or older.',
        buttonLabel: 'Accept',
    },

    termsOfUsePage: {
        title: `{appName:string} Terms and Conditions OF USE (AGREEMENT)`,
    },

    privacyPolicyPage: {
        title: 'Privacy Policy',
    },

    statement2257Page: {
        title: '18 U.S.C. 2257 statement',
    },

    notFoundPage: {
        title: 'Page not found',
    },

    validationErrors: {
        min: '{field:string} must be at least {length:number} chars',
        max: '{field:string} must be no more {length:number} chars',
        notEmpty: 'This field must not be empty',
        nonLatin: 'Use only Latin alphabet characters (A–Z, a–z) and digits (0–9)',
        usernameEmail: {
            required: 'Email or username must not be empty',
        },
        nickname: {
            required: 'Nickname must not be empty',
            format: 'Nickname contains forbidden symbols',
            forbidden: 'Nickname contains forbidden word',
        },
        password: {
            required: 'Password must not be empty',
            newPasswordMustNotBeTheSame: 'New password must not be the same',
            format: 'The password must be at least 8 characters in length and must contain at least one numeric, one special character (such as !, @, #, $, %, ^, &, *) and one lowercase letter or one uppercase',
            equalPassword: 'Should be equal new password',
        },
        email: {
            format: 'Incorrect email',
        },
        spokenLanguages: {
            required: 'Languages required',
        },
        needTickRecaptcha: 'Tick the box so we know you are not a robot',
        required: 'This field is required',
    },

    cameraTurnOff: {
        title: 'Are you sure you want to turn off your camera?',
        subtitle: 'You will be disconnected with your interlocutor',
        buttonLabel: 'Turn off the camera',
    },

    alerts: {
        confirmPageLeave: 'Are you sure you want to leave this page?',
        purchaseSuccess: 'Your purchase has been successful',
        oauthFailure: 'Something went wrong and authorization failed. Please try again',
    },

    unsupportedDevice: {
        title: `Please update your iOS to&nbsp;use&nbsp;{appName:string}`,
        description:
            'Unfortunately, your operating system version is not supported. For the site to work correctly, please update your iOS to version 13 or higher.',
    },

    unsupportedBrowser: {
        title: `Please use another browser`,
        description: 'Unfortunately, your browser is not supported by our platform. For the site to work correctly, please use another browser.',
    },

    unsupportedBrowserV2: {
        title: `Please update your browser to use Flirtify`,
        description: 'It looks like your browser version isn’t supported. To enjoy all features, please update to the latest version.',
        close: 'Got it',
    },

    unstableConnection: {
        title: 'Unstable Connection',
        description: 'Unfortunately, your internet connection appears to be unstable. For the site to work correctly, please check your network settings or try again later.',
    },
} satisfies BaseTranslation;
